export type ContentAudience = 'internal' | 'external';

export const DEFAULT_AUDIENCE: ContentAudience = 'external';

export function isInternalContent(item: { audience?: ContentAudience }): boolean {
    return item.audience === 'internal';
}
